import { getRangeNumbers } from '@/models/GetRangeNumbers'

export const translateFormToSimulation = form => {
  const simulationPlan = translateSimulationPlan(form)
  const menuSetting = translateMenuSetting(form)
  return {
    simulationPlan,
    menuSetting,
  }
}

export const translateFormToE2eSimulation = form => {
  const simulationPlan = translateSimulationPlan(form)
  const menuSetting = translateMenuSetting(form)
  const simulationPlanId = form.basicSetting.id
  return {
    simulationPlan,
    menuSetting,
    simulationPlanId,
  }
}

export const translateSimulationPlan = from => {
  try {
    const { basicSetting, advancedSetting } = from
    const deliveryDaysSpecificHour = translatedDeliveryDaysSpecificHour(
      basicSetting.deliveryDays,
      advancedSetting.deliveryTimeSchedules,
    )

    const menu = (() => {
      const ownerProfileMenu = basicSetting.ownerProfileMenu
      const menu = basicSetting.menus.find(
        menu => menu.id === ownerProfileMenu.id,
      )
      if (menu !== undefined) return menu
      return ownerProfileMenu
    })()

    const grossPrice =
      menu.unitType !== 'cost plus margin' ? menu.grossPrice : undefined

    const costPlusMarginPercent =
      menu.unitType === 'cost plus margin'
        ? menu.costPlusMarginPercentage
        : undefined

    return {
      simulationMenu: {
        menuType: menu.menuType,
        unitType: menu.unitType,
        grossPrice: grossPrice,
        costPlusMarginPercent: costPlusMarginPercent,
        deliveryTargets: [],
        currency: menu.currency,
      },
      creativeType: basicSetting.ownerProfileMenu.creativeType,
      creativeSetting: basicSetting.creativeSetting,
      deliveryDays: basicSetting.deliveryDays,
      useAdvancedSetting: advancedSetting.useAdvancedSetting,
      advancedSetting: {
        deliveryDevices: advancedSetting.deliveryDevices,
        deliveryInventories: advancedSetting.deliveryInventories,
        onlyJapaneseDevice: advancedSetting.onlyJapaneseDevice,
        deliveryDaysSpecificHour,
        age: advancedSetting.demographicSetting.age,
        marriage: advancedSetting.demographicSetting.marriage,
        sex: advancedSetting.demographicSetting.sex,
      },
    }
  } catch (e) {
    console.log(e)
  }
}

const translateMenuSetting = form => {
  const menuSetting = form.deliverySetting.menuSetting
  return {
    targetCode: menuSetting.targetCode,
    minutesAgo: menuSetting.minutesAgo,
    radius: menuSetting.radius,
    simulationLocationGroups: concatSimulationLocationGroups(
      menuSetting.simulationCustomLocationGroups.getSimulatableGroups(),
      menuSetting.simulationPoiLocationGroups.getSimulatableGroups(),
    ),
    enableBulkSetting: menuSetting.enableBulkSetting,
    visitCount: menuSetting.visitCount,
    useLowQualityLocation: true, // TODO 廃止予定
  }
}

const translatedDeliveryDaysSpecificHour = (
  deliveryDays,
  deliveryTimeSchedules,
) => {
  const hours = deliveryTimeSchedules
    .map(({ startHour, endHour }) => getRangeNumbers(startHour, endHour))
    .flat(Infinity)
  return hours.map(hour => ({
    hour,
    days: deliveryDays,
  }))
}

const concatSimulationLocationGroups = (
  customLocationGroups,
  poiLocationGroups,
) => {
  const reformedPoiLocationGroups = poiLocationGroups.map(group => {
    // シュミレーションAPIには地点のデータを送るため条件は必要ない
    return {
      id: group.id,
      name: group.name,
      radius: group.radius,
      simulationLocations: group.simulationLocations,
      status: group.status,
    }
  })
  return [...customLocationGroups, ...reformedPoiLocationGroups]
}
